var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonAvslutad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.251,
    height: 21.814,
    viewBox: "0 0 19.251 21.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avslutad",
    transform: "translate(-8125.838 -6067.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36655",
    "data-name": "Path 36655",
    d: "M135.034,282.254l-3.928-3.8a.75.75,0,0,1,1.043-1.078l2.776,2.685,4.918-5.817a.75.75,0,1,1,1.145.969Z",
    transform: "translate(7999.391 5801.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36665",
    "data-name": "Path 36665",
    d: "M136.092,287.565a9.624,9.624,0,1,1,1.33-19.153.75.75,0,1,1-.211,1.485,8.108,8.108,0,1,0,4.14,1.863.75.75,0,1,1,.973-1.142,9.624,9.624,0,0,1-6.232,16.946Z",
    transform: "translate(7999.391 5801.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36666",
    "data-name": "Path 36666",
    d: "M135.26,272.359a.75.75,0,0,1-.471-1.334l2.358-1.9-2.195-2.082a.75.75,0,0,1,1.032-1.088l3.439,3.264-3.694,2.973A.747.747,0,0,1,135.26,272.359Z",
    transform: "translate(7999.391 5801.714)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonAvslutad);
export default __webpack_public_path__ + "static/media/Ikon_Avslutad.0e602701de40f29e84323461b62fe063.svg";
export { ForwardRef as ReactComponent };